import React from 'react';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingComponent = () => {
  
  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justify='center'
      style={{ minHeight: '100vh' }}>
      <>
        <CircularProgress style={{ marginTop: '300px'}}/>
      </>
    </Grid>
  );
};

export default LoadingComponent;
